import React, { useEffect, useState } from 'react';
import { PlanType } from '../../components/enums/plan-type';
import { formatCurrency } from '../../components/formatters';
import useMsalApi from '../../components/use-msal-api';
import LifeReview from './life-review';

const VoluntaryLifeReview = ({modifiedSelections, unmodifiedSelections, enrollments, addDeduction}) => {
    const [isModified, setIsModified] = useState();
    const [deduction, setDeduction] = useState();
    const [callApi] = useMsalApi();
    
    useEffect(() => {
        if(Array.isArray(enrollments))
            return;
        
        const employee = modifiedSelections.find(s => s.planType === PlanType.VoluntaryLife);
        const spouse = modifiedSelections.find(s => s.planType === PlanType.SpouseLife);
        const child = modifiedSelections.find(s => s.planType === PlanType.ChildLife);

        const getResults = async () => {
            var spouseBirthdate = enrollments.contacts?.find(s => s.relationship.id === "D" || s.relationship.id === "S")?.birthdate;
            var results = await Promise.all([calculateDeduction(employee?.amount || 0, employee?.planId, enrollments.employee.birthdate), calculateDeduction(spouse?.amount || 0, spouse?.planId, spouseBirthdate), calculateDeduction(child?.amount || 0, child?.planId, enrollments.employee.birthdate)]);
            const total = results.reduce((a, b) => a + b, 0)
            setDeduction(total);
            addDeduction(total);
            }

        getResults();
            
    }, [])

    const calculateDeduction = async (amount, planId, birthdate) => {
        if(!amount || !planId)
            return 0;
        var params = {
            coverageAmount: amount,
            effectiveDate: enrollments.effectiveDate,
            birthDate : birthdate,
            planId : planId
        }
        var results = await callApi(`VoluntaryLife`, "POST", params);
        if(!results.error)
           return results

        return 0;

    }

    return ( 
        <div className="mb-4">
            <div className='grid grid-cols-2 items-center mb-2 w-96'>
                <div className='text-xl'>
                <span className={isModified ? 'text-purple' : 'text-danger'}>Voluntary Life</span>
                </div>
                <div className="text-xs border-l border-solid border-slate-600 pl-8">Paycheck Deduction: {formatCurrency(deduction, 2)}</div>
            </div>

            <LifeReview title="Employee" modifiedSelections={modifiedSelections} unmodifiedSelections={unmodifiedSelections} planType={PlanType.VoluntaryLife} setIsModified={setIsModified} />
            <LifeReview title="Spouse" modifiedSelections={modifiedSelections} unmodifiedSelections={unmodifiedSelections} planType={PlanType.SpouseLife} setIsModified={setIsModified} />
            <LifeReview title="Child(ren)" modifiedSelections={modifiedSelections} unmodifiedSelections={unmodifiedSelections} planType={PlanType.ChildLife} setIsModified={setIsModified} />
            <hr />
        </div>
     );
}
 
export default VoluntaryLifeReview;